import React, { useEffect, useRef, useState } from "react";
import "./ZynvertStandard.css";

const ZynvertStandard = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const steps = [
    {
      num: "01",
      title: "Cell Sorting",
      desc: "Every cell is tested for Internal Resistance (IR) and voltage matching to ensure a perfectly balanced pack.",
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="16" height="16" x="4" y="4" rx="2"/><path d="M9 9h6"/><path d="M9 15h6"/><path d="M12 6v12"/></svg>
    },
    {
      num: "02",
      title: "Spot Welding",
      desc: "Using pure nickel strips and industrial welders, we create low-resistance connections for maximum power flow.",
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m13 2-2 10h9l-7 10"/><path d="M5 14h.01"/><path d="M8 11h.01"/><path d="M4 10h.01"/></svg>
    },
    {
      num: "03",
      title: "BMS Integration",
      desc: "A Smart Battery Management System is installed to protect against overcharging, deep discharge, and shorts.",
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="10" x="3" y="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
    },
    {
      num: "04",
      title: "Final Testing",
      desc: "Every pack undergoes a full charge/discharge cycle and load test. You receive a performance report with delivery.",
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
    }
  ];

  return (
    <section className={`process-section ${isVisible ? "is-animated" : ""}`} ref={sectionRef}>
      <div className="process-container">
        
        <div className="process-header">
          <h2 className="process-title">Zynventics Standard</h2>
          <p className="process-subtitle">Safety isn't optional. Here is how we build your custom battery pack with precision engineering.</p>
        </div>

        <div className="steps-wrapper">
          {steps.map((step, index) => (
            <div className="process-step" key={index}>
              <div className="step-number-container">
                <div className="step-number">{step.num}</div>
                {index < steps.length - 1 && <div className="step-connector"></div>}
              </div>
              <div className="step-card">
                <div className="step-icon-box">{step.icon}</div>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="trust-strip">
          <div className="trust-item">🇮🇳 Made in India</div>
          <div className="trust-item">💎 Grade A Cells</div>
          <div className="trust-item">🛡️ Warranty Included</div>
          <div className="trust-item">🚚 Pan-India Shipping</div>
        </div>

      </div>
    </section>
  );
};

export default ZynvertStandard;